import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectEnabledFeatures, selectResolvedFlags } from 'store/features/selectors';
import { selectIsPaid } from 'store/user/selectors';

import { NavAccess } from './types';

/** Assemble `NavAccess` from the `auth`, `user` and `features` slices (sidebar / enforce). */
export const useNavAccess = (): NavAccess => {
    const isPaid = useSelector(selectIsPaid);
    const flags = useSelector(selectResolvedFlags);
    const features = useSelector(selectEnabledFeatures);

    // Memoize so consumers' `useMemo`/effects keyed on `navAccess` don't re-run every render.
    return useMemo(() => ({ isPaid, flags, features }), [isPaid, flags, features]);
};
